/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Editors_Eyebrow_Body_TodayInputs */

const en_us2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Body · today, ${i?.date}`)
};

const pt_br2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corpo · hoje, ${i?.date}`)
};

const es_419_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuerpo · hoy, ${i?.date}`)
};

const pt_pt2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corpo · hoje, ${i?.date}`)
};

const fr_fr2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corps · aujourd'hui, ${i?.date}`)
};

const de_de2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Körper · heute, ${i?.date}`)
};

const it_it2_profile_editors_eyebrow_body_today = /** @type {(inputs: Profile_Editors_Eyebrow_Body_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corpo · oggi, ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Body · today, {date}" |
*
* @param {Profile_Editors_Eyebrow_Body_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_body_today = /** @type {((inputs: Profile_Editors_Eyebrow_Body_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_Body_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_body_today(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_body_today(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_body_today(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_body_today(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_body_today(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_body_today(inputs)
	return en_us2_profile_editors_eyebrow_body_today(inputs)
});
export { profile_editors_eyebrow_body_today as "profile-editors.eyebrow_body_today" }